
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import moment from 'moment';
    import { validarCuit } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        //Mascara: string = '##-########-#';
        Mascara: string = '########'

        @Prop( { type: String } )
        public value: string;

        @Prop( { type: String, default: 'Fecha:' } )
        public Titulo: string;

        @Prop( { type: Boolean } )
        public disabled: boolean;

        @Prop( { type: Boolean } )
        public readonly: boolean;

        Visible: boolean = true;

        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            this.Selected = this.value;
        }

        public selected: string | null = null;
        public get Selected(): string | null
        {
            return this.selected;
        }
        public set Selected( x: string | null )
        {
            this.selected = x;
            this.$emit( 'input', this.Selected);
        }

        public async onLostFocus( event: any )
        {
            if ( this.Selected )
                this.Error = this.Selected.length != 8;

            if ( !this.Error && this.Selected )
                this.Error = !moment( this.Selected, 'DDMMYYYY' ).isValid();

            if ( !this.Error && this.Selected )
            {
                this.Mascara = '##-##-####';
                this.Selected = moment( this.Selected, 'DDMMYYYY' ).toFechaCorta();
            } else
            {
                this.Selected = '';
            }
        }

        public async onGotFocus( event: any )
        {
            this.Error = false;
            this.Mascara = '########';
            this.Selected = this.Selected.replace( '-', '' );
        }

        public Error: boolean = false;

    }
